import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { SamoletPage403 } from './components/SamoletPage403';

export const Page403: FC = () => {
  const { replace } = useHistory();

  const onClickMainPage = useCallback(() => replace('/'), [replace]);

  return <SamoletPage403 onClickMainPage={onClickMainPage} />;
};
